export const getAuthState = (state: any) => state.auth;
